import { render, staticRenderFns } from "./sport_view.vue?vue&type=template&id=5fa1a8c7&"
import script from "./sport_view.vue?vue&type=script&lang=js&"
export * from "./sport_view.vue?vue&type=script&lang=js&"
import style0 from "./sport_view.vue?vue&type=style&index=0&id=5fa1a8c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports